import React, { Component } from "react";

import { Row, Col, Divider, Card } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/InsuranceKnowledge/Books/Books.css";

const summaryTitle = {
  fontFamily: "IranSans",
  fontSize: "1em",
  color: "#174561",
  direction: "rtl",
  textAlign: "right",
  padding: "20px",
};
const summaryTitleTablet = {
  fontFamily: "IranSans",
  fontSize: ".9em",
  color: "#174561",
  direction: "rtl",
  textAlign: "right",
  padding: "20px",
};
const summaryTitleMobile = {
  fontFamily: "IranSans",
  fontSize: ".85em",
  color: "#174561",
  direction: "rtl",
  textAlign: "right",
  padding: "20px",
};

const summaryHr = {
  border: "0.01em dashed #4983C4",
  width: "100%",
  marginTop: "0px",
  marginRight: "20px",
  marginLeft: "20px",
};


const ArticlesInsideSummary = (props) => {
  return props.size === "laptopdesktop" ? (
    <div style={{ backgroundColor: "#f9f9f9" }}>
      <Row>
        <Col span={4}></Col>
        <Col span={16}>
          <Margin top={4}></Margin>
          <div style={{ backgroundColor: "#fff", borderRadius: "15px" }}>
            <p style={summaryTitle}>
              <strong>چکیده مقاله</strong>
            </p>
            <Row style={{ marginTop: "-20px" }}>
              <Col span={2}></Col>
              <Col span={20}>
                <p className="textParagraph">
                {props.article.about_article}
                </p>
              </Col>
              <Col span={2}></Col>
            </Row>
            <Row>
              <hr style={summaryHr} />
            </Row>
            <p style={summaryTitle}>
              <strong>مشخصات نویسندگان:</strong>
            </p>
            <Row style={{ marginTop: "-20px" }}>
              <Col span={2}></Col>
              <Col span={20}>
                <p className="textParagraph">
                  {props.article.writer}

                </p>                
              </Col>
              <Col span={2}></Col>
            </Row>
            <Row>
              <hr style={summaryHr} />
            </Row>
            <p style={summaryTitle}>
              <strong>کلید واژه ها:</strong>
            </p>
            <Row style={{ marginTop: "-20px" }}>
              <Col span={2}></Col>
              <Col span={20}>
                <Row style={{ direction: "rtl" }}>
                  <p className="textParagraph">
                      {props.article.keywords}
                    {/* بیمه، بیمه عمر، بیمه شخص ثالث. */}
                  </p>
                </Row>
              </Col>
              <Col span={2}></Col>
            </Row>
          </div>
          <Margin bottom={4}></Margin>
        </Col>
        <Col span={4}></Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
      <div style={{ backgroundColor: "#f9f9f9" }}>
        <Row>
          <Col span={2}></Col>
          <Col span={20}>
            <Margin top={4}></Margin>
            <div style={{ backgroundColor: "#fff", borderRadius: "15px" }}>
              <p style={summaryTitleTablet}>
                <strong>چکیده مقاله</strong>
              </p>
              <Row style={{ marginTop: "-20px" }}>
                <Col span={2}></Col>
                <Col span={20}>
                  <p className="textParagraphTablet">
                    {props.article.about_article}
                  </p>
                </Col>
                <Col span={2}></Col>
              </Row>
              <Row>
                <hr style={summaryHr} />
              </Row>
              <p style={summaryTitleTablet}>
                <strong>مشخصات نویسندگان:</strong>
              </p>
              <Row style={{ marginTop: "-20px" }}>
                <Col span={2}></Col>
                <Col span={20}>
                  <p className="textParagraphTablet">
                    {props.article.writer}
                  </p>

                </Col>
                <Col span={2}></Col>
              </Row>
              <Row>
                <hr style={summaryHr} />
              </Row>
              <p style={summaryTitleTablet}>
                <strong>کلید واژه ها:</strong>
              </p>
              <Row style={{ marginTop: "-20px" }}>
                <Col span={2}></Col>
                <Col span={20}>
                  <Row style={{ direction: "rtl" }}>
                    <p className="textParagraph">
                      {props.article.keywords}
                    </p>
                  </Row>
                </Col>
                <Col span={2}></Col>
              </Row>
            </div>
            <Margin bottom={4}></Margin>
          </Col>
          <Col span={2}></Col>
        </Row>
      </div>
  ) : (
        <div style={{ backgroundColor: "#f9f9f9" }}>
          <Row>
            <Col span={1}></Col>
            <Col span={22}>
              <Margin top={4}></Margin>
              <div style={{ backgroundColor: "#fff", borderRadius: "15px" }}>
                <p style={summaryTitleMobile}>
                  <strong>چکیده مقاله</strong>
                </p>
                <Row style={{ marginTop: "-20px" }}>
                  <Col span={2}></Col>
                  <Col span={20}>
                    <p className="textParagraphMobile">
                      {props.article.about_article}
                    </p>
                  </Col>
                  <Col span={2}></Col>
                </Row>
                <Row>
                  <hr style={summaryHr} />
                </Row>
                <p style={summaryTitleMobile}>
                  <strong>مشخصات نویسندگان:</strong>
                </p>
                <Row style={{ marginTop: "-20px" }}>
                  <Col span={2}></Col>
                  <Col span={20}>
                    <p className="textParagraphMobile">
                      {props.article.writer}

                    </p>
                  </Col>
                  <Col span={2}></Col>
                </Row>
                <Row>
                  <hr style={summaryHr} />
                </Row>
                <p style={summaryTitleMobile}>
                  <strong>کلید واژه ها:</strong>
                </p>
                <Row style={{ marginTop: "-20px" }}>
                  <Col span={2}></Col>
                  <Col span={20}>
                    <Row style={{ direction: "rtl" }}>
                      <p className="textParagraphMobile">
                        {props.article.keywords}
                      </p>
                    </Row>
                  </Col>
                  <Col span={2}></Col>
                </Row>
              </div>
              <Margin bottom={4}></Margin>
            </Col>
            <Col span={1}></Col>
          </Row>
        </div>
  );
};

export default ArticlesInsideSummary;
